import { useMutation } from "react-query";
import { useApi, apiResolver } from "../useApi";
import {
  CreateWorkspaceRequest,
  CreateWorkspaceResponse,
} from "./Workspace.model";
import { AxiosInstance } from "axios";

export function useWorkspaceApi(api: AxiosInstance) {
  return {
    createWorkspace: async (
      request: CreateWorkspaceRequest
    ): Promise<CreateWorkspaceResponse> => {
      const data = await apiResolver<CreateWorkspaceResponse>(
        api.post(`/platform/workspace/${request.subdomain}`, request)
      );
      return data;
    },
  };
}

export function useCreateWorkspace() {
  const { api } = useApi();
  const workspaceApi = useWorkspaceApi(api);

  return useMutation({
    mutationKey: ["createWorkspace"],
    mutationFn: workspaceApi.createWorkspace,
  });
}
